// extracted by mini-css-extract-plugin
export default {"container":"styles_container__aT5X7","body":"styles_body__DGCjx","content":"styles_content__+3CY-","image":"styles_image__ug3l8","sticky":"styles_sticky__seyF7"};